/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Manage_Rename_SaveInputs */

const en_us2_coach_manage_rename_save = /** @type {(inputs: Coach_Manage_Rename_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save`)
};

const pt_br2_coach_manage_rename_save = /** @type {(inputs: Coach_Manage_Rename_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar`)
};

const es_419_coach_manage_rename_save = /** @type {(inputs: Coach_Manage_Rename_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar`)
};

const pt_pt2_coach_manage_rename_save = /** @type {(inputs: Coach_Manage_Rename_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar`)
};

const fr_fr2_coach_manage_rename_save = /** @type {(inputs: Coach_Manage_Rename_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer`)
};

const de_de2_coach_manage_rename_save = /** @type {(inputs: Coach_Manage_Rename_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speichern`)
};

const it_it2_coach_manage_rename_save = /** @type {(inputs: Coach_Manage_Rename_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva`)
};

/**
* | output |
* | --- |
* | "Save" |
*
* @param {Coach_Manage_Rename_SaveInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_manage_rename_save = /** @type {((inputs?: Coach_Manage_Rename_SaveInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Manage_Rename_SaveInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_manage_rename_save(inputs)
	if (locale === "es-419") return es_419_coach_manage_rename_save(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_manage_rename_save(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_manage_rename_save(inputs)
	if (locale === "de-DE") return de_de2_coach_manage_rename_save(inputs)
	if (locale === "it-IT") return it_it2_coach_manage_rename_save(inputs)
	return en_us2_coach_manage_rename_save(inputs)
});
export { coach_manage_rename_save as "coach-manage.rename_save" }